import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/final-grade-calculator',
  component: () => import('../../routes/FinalGradeCalculator.svelte'),
  card: {
    id: 'final-grade-calculator',
    title: 'Final Grade Calculator',
    description: 'Find out what score you need on your final exam to reach your target grade.',
    icon: 'school',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/final-grade-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Final Grade Calculator – What Do I Need on My Final?',
    description: 'Calculate the exact score you need on your final exam to reach your target grade. Enter your current grade and weight to find out what you must score.',
  },
};

export default meta;